import React, { useState, useRef, useEffect } from "react";
import { FaEllipsisV } from "react-icons/fa";

function _OrderRow({ order, menuOpenId, setMenuOpenId, isSelected, onSelect }) {
  const [isOpen, setIsOpen] = useState(false);
  const contentRef = useRef(null);
  const [height, setHeight] = useState("0px");

  const isMenuOpen = menuOpenId === order.COI_ID;

  const formatToMMDDYYYY = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);

    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    const yyyy = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; // Convert to 12-hour format

    return `${mm}/${dd}/${yyyy} ${hours}:${minutes} ${ampm}`;
  };

  useEffect(() => {
    if (contentRef.current) {
      setHeight(isOpen ? "200px" : "0px");
    }
  }, [isOpen]);

  return (
    <tr>
      {/* Select Checkbox */}
      <td></td>

      <td>
        <img
          src={`${process.env.REACT_APP_BASE_URL}Assets/Products/${
            order.PD_ID
          }/${order.PD_ProductPicPath[0] ?? "no-image.png"}`}
          alt={order.PD_Name}
          className="ord-prod-pic"
        />
      </td>
      <td>{order.PD_Name}</td>
      <td>{order.CP_Firstname + " " + order.CP_Lastname}</td>
      <td>{formatToMMDDYYYY(order.COI_Updated_At)}</td>
      <td>{order.COI_CancelBy}</td>
      <td>{order.COI_CancelReason}</td>
      <td>
        {order.COI_Status === "Paid" ? "FP Paid" : order.COI_Status || ""}
      </td>
    </tr>
  );
}

export default _OrderRow;
